<template>
    <section id="result-search-page">
        <div :class="containerClasses">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>Viewed Vehicles</h2>
                        </div>
                        <div class="right">
                        </div>
                    </div>
                    <div class="bottom space-between">
                        <div class="left">
                            <span v-if="total > 0" class="showing select-all">
                                <strong>Showing</strong>
                                <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                                results
                            </span>
                            <div class="view-type-selection select-all">
                                <label for="view-grid" :class="viewType === 'grid' ? 'active' : ''">
                                    <input id="view-grid" type="radio" value="grid" v-model="viewType" @change="onViewChange"/>
                                    <icon icon=" fa-lg fa-th"></icon>
                                </label>
                                <label for="view-list" :class="viewType === 'list' ? 'active' : ''">
                                    <input id="view-list" type="radio" value="list" v-model="viewType" @change="onViewChange"/>
                                    <icon icon=" fa-lg fa-list"></icon>
                                </label>
                            </div>
                            <select v-if="viewType === 'grid'" class="per-row" v-model="perRow">
                                <option v-for="option in vehicles_in_row_options" :value="option.value">
                                    {{ option.text }}
                                </option>
                            </select>
                        </div>
                        <div class="right">
                        </div>
                    </div>
                    <div class="bottom filters">
                        <RecentDatesSelector  :showAll="false" id="role" v-model="date_option" @change="getData()" :custom="{custom: 'Custom', all_past: 'All Past'}">
                            <option value="">Filter By Date</option>
                        </RecentDatesSelector>
                        <div v-if="date_option === 'custom'">
                            <label for="custom_date">&nbsp;</label>
                            <b-form-input type="date" id="custom_date" v-model="custom_date"></b-form-input>
                        </div>
                    </div>
                </div>
                <div class="container-table col-md-12">
                    <div v-if="total === 0">
                        <p>
                            Vehicles not found.
                        </p>
                    </div>
                    <div v-else>
                        <div id="bid-history" v-if="viewType === 'list'">
                            <div class="all-bid table-responsive" v-if="vehicleViews">
                                <table class="bid-history table">
                                    <thead>
                                    <tr>
                                        <th>(+/-)</th>
                                        <th>Day</th>
                                        <th>
                                            <a href="#!" title="Click to sort by auction"
                                               @click.prevent="toggleSorting('auc_asc', 'auc_desc')">
                                                Auc
                                            </a>/
                                            <a href="#!" title="Click to sort by lot"
                                               @click.prevent="toggleSorting('lot_asc', 'lot_desc')">
                                                Lot
                                            </a>
                                        </th>
                                        <th>ID</th>
                                        <th>Make</th>
                                        <th>Model/Grade</th>
                                        <th>Chassis</th>
                                        <th>Year</th>
                                        <th>Kms</th>
                                        <th>Colour</th>
                                        <th>CC</th>
                                        <th>Trans</th>
                                        <th>F</th>
                                        <th>Cnd</th>
                                        <th></th>
                                        <th>Start</th>
                                        <th @click="sortOrderBy = 'auction_date'" title="Click to sort by auction date ">
                                            Result
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="(data,index) in vehicleViews">
                                        <tr v-if="!data.vehicle" :key="'nodata-'+data.vehicle_id" class="hr">
                                            <td colspan="17">No data for vehicle {{data.vehicle_id}}</td>
                                        </tr>
                                        <tr v-else @contextmenu.prevent="tagPopupModal(data.vehicle.api_id)" :key="data.vehicle.api_id" class="hr">
                                            <td class="tag">
                                                <input type="checkbox" :id="`tag-${data.vehicle.api_id}`" @change="onFavChange(data.vehicle.api_id)" :value="true" v-model="vehicleFavourites[data.vehicle.api_id]"/>
                                                <label :for="`tag-${data.vehicle.api_id}`"></label>
                                                <small>Tag</small>
                                            </td>
                                            <td class="date">
                                                {{ getDate(data.vehicle.auction_date) }}
                                            </td>
                                            <td class="yellow">
                                                <a :href="data.vehicle.detail_url" @click.prevent="goToCar(data.vehicle)">
                                                    <div>{{ data.vehicle.auction_house }}</div>
                                                    <div>{{ data.vehicle.lot }}</div>
                                                </a>
                                            </td>
                                            <td class="id-bid">
                                                <a :href="data.vehicle.detail_url" @click.prevent="goToCar(data.vehicle)">
                                                    {{ data.vehicle.api_id }}
                                                </a>
                                                <div class="image-hover-container">
                                                    <vehicle-hover-images :vehicle="data.vehicle" :letters_only="true"></vehicle-hover-images>
                                                </div>
                                            </td>
                                            <td class="make">
                                                {{ data.vehicle.make }}
                                            </td>
                                            <td class="model">
                                                {{ data.vehicle.model }} / {{ data.vehicle.grade }}
                                            </td>
                                            <td>
                                                {{ data.vehicle.chassis }}
                                            </td>
                                            <td>
                                                {{ data.vehicle.year }}
                                            </td>
                                            <td>
                                                {{ data.vehicle.mileage }}
                                            </td>
                                            <td class="color">
                                                {{ data.vehicle.color }}
                                            </td>
                                            <td>
                                                {{ data.vehicle.engine_capacity }}
                                            </td>
                                            <td>
                                                {{ data.vehicle.transmission }}
                                            </td>
                                            <td>
                                                {{ data.vehicle.fuel_type }}
                                            </td>
                                            <td>
                                                {{ data.vehicle.condition }}
                                            </td>
                                            <td>
                                                {{ data.vehicle.equipment }}
                                            </td>
                                            <td class="blue">
                                                ¥ {{ data.vehicle.start_price }}
                                            </td>
                                            <td v-if="!is_mobile" :class="isSold(data.vehicle.auction_date) ? 'sold' : ''">
                                                <small :title="getJapanDiff(data.vehicle.auction_date)">
                                                    {{ getTime(data.vehicle.auction_date, 'h:mma') }} JPN /
                                                    {{ getNZDateTime(data.vehicle.auction_date).format('h:mma') }} NZ
                                                </small>
                                                <div v-if="data.vehicle.hw_auc_cost > 0">
                                                    <strong v-if="data.vehicle.hw_auc_status">{{data.vehicle.hw_auc_status}}</strong>
                                                    <br/>
                                                    <span :title="numberWithCommas(data.vehicle.hw_auc_cost) + 'k yen'" class="blue">
                                                    ¥ {{ numberWithCommas(data.vehicle.hw_auc_cost) }} k
                                                </span>
                                                </div>
                                                <div v-else-if="isSold(data.vehicle.auction_date)">
                                                    <span v-if="data.vehicle.bid_status === 'negotiation'">Negotiation</span>
                                                    <span v-else-if="data.vehicle.bid_status === 'cancelled'">Cancelled</span>
                                                    <span v-else-if="data.vehicle.bid_status === 'sold'">Sold</span>
                                                    <span v-else>Not sold</span>
                                                    <template v-if="data.vehicle.end_price && data.vehicle.end_price > 0">
                                                        <br/>
                                                        <span :title="numberWithCommas(data.vehicle.end_price) + ' yen'"
                                                              class="blue">
                                                        ¥ {{ numberWithCommas(data.vehicle.end_price / 1000) }} k
                                                    </span>
                                                    </template>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="is_mobile">
                                            <td colspan="14" :class="isSold(data.vehicle.auction_date) ? 'sold' : ''">
                                                <small :title="getJapanDiff(data.vehicle.auction_date)">
                                                    {{ getTime(data.vehicle.auction_date, 'h:mma') }} JPN /
                                                    {{ getNZDateTime(data.vehicle.auction_date).format('h:mma') }} NZ
                                                </small>
                                                <div v-if="data.vehicle.hw_auc_cost > 0">
                                                    <strong v-if="data.vehicle.hw_auc_status">{{data.vehicle.hw_auc_status}}</strong>
                                                    <br/>
                                                    <span :title="numberWithCommas(data.vehicle.hw_auc_cost) + 'k yen'" class="blue">
                                                    ¥ {{ numberWithCommas(data.vehicle.hw_auc_cost) }} k
                                                </span>
                                                </div>
                                                <div v-else-if="isSold(data.vehicle.auction_date)">
                                                    <span v-if="data.vehicle.bid_status === 'negotiation'">Negotiation</span>
                                                    <span v-else-if="data.vehicle.bid_status === 'cancelled'">Cancelled</span>
                                                    <span v-else-if="data.vehicle.bid_status === 'sold'">Sold</span>
                                                    <span v-else>Not sold</span>
                                                    <template v-if="data.vehicle.end_price && data.vehicle.end_price > 0">
                                                        <br/>
                                                        <span :title="numberWithCommas(data.vehicle.end_price) + ' yen'"
                                                              class="blue">
                                                        ¥ {{ numberWithCommas(data.vehicle.end_price / 1000) }} k
                                                    </span>
                                                    </template>
                                                </div>
                                            </td>
                                        </tr>
                                        <template v-if="data.vehicle">
                                            <tr v-for="bid in data.vehicle.bids">
                                                <td colspan="17">
                                                    <div class="bid">
                                                        <div class="date item">
                                                            {{ getDate(bid.created_at) }}
                                                        </div>
                                                        <div class="hour item">
                                                            {{ getTime(bid.created_at) }}
                                                        </div>
                                                        <div class="note item">
                                                            <strong>{{bid.note}}</strong>
                                                            [SystemNote: {{bid.bid_by_name}};
                                                            landed={{bid.currency_sign}}{{ formatNumber(bid.bid_price_landed)}}; FX={{
                                                                bid.exchange_rate}}]
                                                        </div>
                                                        <div class="item bid-details-container" :style="bidColourStyle(bid)">
                                                            <div class="who" v-if="bid.user" >
                                                                <a href="#!" @click="filterBidUser(bid.user.id)" class="person">{{ bid.user.name}}</a>
                                                                <span v-if="bid.user.company">{{ bid.user.company.name}}</span>
                                                                <span class="bump">{{ bumpBidDisplay(bid.bump_bid) }}</span>
                                                            </div>
                                                            <div class="bid-placed">
                                                                <div :class="bid.bump_bid ? 'strikeout' : ''">
                                                                    ¥ {{ numberWithCommas(bid.bid_price_jpy)}}
                                                                </div>
                                                                <div v-if="bid.bump_bid" class="bid-total">
                                                                    Cost ¥ {{ numberWithCommas(bid.bid_price_jpy + bid.bump_bid)}}
                                                                </div>
                                                            </div>
                                                            <div class="tag">
                                                                <input type="checkbox" :id="`bidtag-${bid.id}`" @change="onBidFavChange(bid.id)" :value="true" v-model="bidFavourites[bid.id]"/>
                                                                <label :for="`bidtag-${bid.id}`"></label>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div :id="'bid-messages-' + bid.id" class="collapse show" v-if="bid.messages">
                                                        <template v-for="msg in bid.messages">

                                                            <div class="bid history-bid" :class="messageClass(msg, bid)" @click="selectMessage(msg)">
                                                                <!--
                                                                <div class="cross item">
                                                                    <button><img src="../../images/cross.svg" alt="Collapse"></button>
                                                                </div>
                                                                -->
                                                                <div class="date item">
                                                                    {{ getDate(msg.created_at) }}
                                                                </div>
                                                                <div class="hour item">
                                                                    {{ getTime(msg.created_at) }}
                                                                </div>
                                                                <div class="message-by item">
                                                                    {{ msg.firstname }} {{ msg.lastname }}
                                                                </div>
                                                                <div class="note item">
                                                                    <span>
                                                                        <strong v-if="msg.rep_only">staff: </strong>
                                                                        {{msg.message}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                    <div class="history-buttons">
                                                        <a class="link add-message" @click="openMessageModal(bid)">
                                                            <template v-if="$userIsAdmin()"> Client Message </template>
                                                            <template v-else>Add Message</template>
                                                        </a>
                                                        <template v-if="$userIsAdmin()">
                                                            <a class="link copy-stock" @click="copyVehicleToStock(data.api_id)" :class="copiedToStock.indexOf(data.api_id) !== -1 ? 'disabled' : ''">
                                                                Copy to dealer stock
                                                            </a>
                                                        </template>
                                                        <a class="link staff-message" @click="openChangeBidModal(bid)" :disabled="!$canChangeBid(data.auction_date)">Change bid</a>
                                                        <template v-if="bid.sbl_id && $userIsAdmin()">
                                                            <a class="link staff-message" @click="addBidMessage(bid.id, keepBidMsg, true)">Keep Bid</a>
                                                            <a v-if="bid.bid_price_jpy" class="link staff-message" @click="cancelBid(bid.id)">Cancel bid</a>
                                                            <a class="link staff-message" @click="openChangeBidModal(bid)">Change bid</a>
                                                        </template>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="container-results" id="container-results" v-else>
                            <template v-if="vehicleViews && vehicleViews.length">
                                <Vehicle v-for="view of vehicleViews" :key="view.id"
                                         :vehicle="view.vehicle"
                                         priceField="start_price"
                                         @tagPopupModal="tagPopupModal">
                                </Vehicle>
                            </template>
                            <template v-else>
                                <template v-if="loading">
                                    Loading...
                                </template>
                                <template v-else>
                                    No Bids found.
                                </template>
                            </template>
                            <div class="single-result-search none" v-for="vehicle of [1,2,3,4,5,6,7,8]"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 d-flex justify-content-end">
                    <b-pagination
                            v-if="total > 0"
                            :total-rows="total"
                            v-model="current_page"
                            :per-page="per_page"
                    ></b-pagination>
                </div>
                <favourite-tag-modal
                    v-if="$userCan('fav_list')"
                        :vehicleId=vehicle_id
                        v-model="favListModalOpen"
                        @changed="onTagChanged"
                ></favourite-tag-modal>
                <change-bid ref="changeBidModal" @changed="onBidChange"/>
                <bid-message ref="bidMessage" @changed="onBidChange"/>
                <staff-message ref="staffMessage" @changed="onBidChange"/>
            </div>
        </div>
    </section>
</template>
<script>

import {mapState, mapActions, mapMutations} from 'vuex'
import {
    handleHttpError, numberWithCommas, objToUrl,
    getDateTime,
    getNZDateTime,
    getJapanDiff, setBackToAll, addToUrlQuery
} from '../util/common'

import changeBid from './VehicleSingle/ChangeBid.vue';
import bidMessage from './VehicleSingle/BidMessage.vue';
import Vehicle from './Common/Vehicle.vue';
import moment from 'moment'
import staffMessage from './VehicleSingle/StaffMessage.vue';
import RecentDatesSelector from './Common/RecentDatesSelector'
import VehicleHoverImages from './Common/VehicleHoverImages'
import _ from 'underscore'
import LaravelRouter from "../thirdparty/Ziggy/route";

    export default {
        components: {
            'change-bid': changeBid,
            'bid-message': bidMessage,
            'staff-message': staffMessage,
            RecentDatesSelector,
            Vehicle,
            VehicleHoverImages
        },
        created() {
            this.fillSearchFields()
            this.$store.dispatch('users/getUsers', {
                sort_by: 'first_name',
                sort_asc: true,
                per_page: 500,
                filter_by_status: 1
            });
            this.sort_by = this.sortOrderBy
            this.getData();
            this.$store.dispatch('auction_nextprev/checkStack');
            this.$store.dispatch('auction_nextprev/checkListReturn', this.$route.query.state_key || null)
            setBackToAll(window.location.pathname + window.location.search);
        },
        beforeRouteUpdate(){
            this.checkStack()
        },
        mounted() {
            let user_bid = this.userHasBid;
            if (user_bid) {
                this.estimatedLandedCost = user_bid.bid_price_landed;
                this.bidPriceProxy = user_bid.bid_price_jpy / 1000;
                this.bidPrice = user_bid.bid_price_jpy;
            }
            // Register an event listener when the Vue component is ready
            window.addEventListener('resize', this.onResize)
            this.is_mobile = window.innerWidth < 760;
        },
        beforeDestroy() {
            // Unregister the event listener before destroying this Vue instance
            window.removeEventListener('resize', this.onResize)
        },
        data() {
            return {
                is_mobile: false,
                sort_by: 'auction_date',
                sort_asc: true,
                viewType: 'list',
                perRow: 5,
                change_bid_id: null,
                keepBidMsg: 'Keep bid',
                cancelBidMsg: 'Cancel bid',
                user: null,
                estimatedLandedCost: '',
                bidPrice: 0,
                bidPriceProxy: null,
                bidNote: '',
                showBids: [],
                copiedToStock: [],
                vehicleFavourites: {},
                bidFavourites: {},
                agentUsers: [],
                favListModalOpen: false,
                vehicle_id: null,
                username: this.filter_by_username,
                hoveredImageVehicleId: null,
                vehicles_in_row_options: [
                    {value: 0, text: 'FULL WIDTH'},
                    {value: 5, text: '5 per row'},
                    {value: 6, text: '6 per row'},
                ],
                selectedMessage: null,
            }
        },
        watch: {
            date: function (val) {
                if (!this.date_option || val) {
                    this.getData();
                }
            },
            sortOrderBy: function (value) {
                this.sort_by = this.order_options[value].field;
                this.sort_asc = this.order_options[value].order_asc;
                this.current_page = 1;
            },
        },
        computed: {
            ...mapState({
                users: state => state.users.all,
                vehicleViews: state => state.vehicleViews.all,
                ids: state => state.vehicleViews.ids,
                per_page: state => state.vehicleViews.per_page,
                from: state => state.vehicleViews.from,
                to: state => state.vehicleViews.to,
                last_page: state => state.vehicleViews.last_page,
                total: state => state.vehicleViews.total,
            }),
            current_page: {
                get() {
                    return this.$store.getters['vehicleViews/getCurrentPage'];
                },
                set(value) {
                    this.getData({page: value});
                }
            },
            date: {
                get() {
                    if (this.date_option === 'custom') {
                        return this.custom_date;
                    }
                    return this.date_option
                }
            },
            containerClasses() {
                let classes = ['container'];
                if (this.perRow === 0 || this.viewType === 'list') {
                    classes.push('full-width');
                } else if (this.perRow === 5) {
                    classes.push('per-5');
                } else if (this.perRow === 6) {
                    classes.push('per-6');
                }
                return classes.join(' ');
            },
            date_option: {
                get () {
                    return this.$store.getters['vehicleViews/getDateOption']
                },
                set (value) {
                    this.$store.commit('vehicleViews/setDateOption', value)
                }
            },
            custom_date: {
                get () {
                    return this.$store.getters['vehicleViews/getCustomDate']
                },
                set (value) {
                    this.$store.commit('vehicleViews/setCustomDate', value)
                }
            }
        },
        methods: {
            onResize(event) {
                this.is_mobile = event.target.innerWidth < 760;
            },
            ...mapActions({
                translateGrades: 'auction_search/translateGrades',
                copyVehicleToStockAction: 'auction_search/copyVehicleToStock',
                checkStack: 'auction_nextprev/checkStack',
                addToNextPrevStack: 'auction_nextprev/addToStack',
            }),
            ...mapMutations({
                setSingleVehicle: 'auction_search/setSingleVehicle',
                updateViewMessages: 'vehicleViews/updateBidMessages',
            }),
            async copyVehicleToStock(vid) {
                try{
                    if (this.copiedToStock.indexOf(vid) === -1) {
                        this.copiedToStock.push(vid)
                        this.copyVehicleToStockAction(vid)
                        this.$message.success('Vehicle copied to stock.')
                    }
                } catch (e) {
                    this.$message.error('There was a problem copying vehicle to stock.')
                    console.warn(e)
                }
            },
            getDateTime,
            getNZDateTime,
            getJapanDiff,
            numberWithCommas,
            goToCar(vehicle){
                this.setSingleVehicle(vehicle)
                let url = vehicle.detail_url
                if (window.history && window.history.state && window.history.state.key) {
                    this.$store.dispatch('auction_nextprev/leavingListPage')
                    url = addToUrlQuery(url, {state_key: window.history.state.key})
                }
                this.$router.push(url);
            },
            toggleSorting(first, second = null){
                if (second) {
                    if (this.sortOrderBy === first) {
                        this.sortOrderBy = second
                    } else {
                        this.sortOrderBy = first
                    }
                } else {
                    this.sortOrderBy = first
                }
            },
            isSold(auction_date) {
                let date = window.moment.tz(auction_date, 'Asia/Tokyo');
                let now = window.moment.tz(window.moment(), 'Asia/Tokyo');
                return now > date;
            },
            fillSearchFields(){
                if (this.$route.query.filter_by_date) {
                    if (this.$route.query.filter_by_date === 'all_past') {
                        this.date_option = 'all_past'
                    } else{
                        let dates = [
                            moment().subtract(3, 'd').format('YYYY-MM-DD'),
                            moment().subtract(2, 'd').format('YYYY-MM-DD'),
                            moment().subtract(1, 'd').format('YYYY-MM-DD'),
                            moment().format('YYYY-MM-DD'),
                            moment().add(1, 'd').format('YYYY-MM-DD'),
                            moment().add(2, 'd').format('YYYY-MM-DD'),
                            moment().add(3, 'd').format('YYYY-MM-DD'),
                        ];
                        let found = false
                        dates.forEach(date => {
                            if (date === this.$route.query.filter_by_date) {
                                found = true
                            }
                        })
                        if (found) {
                            this.date_option = this.$route.query.filter_by_date
                        } else {
                            this.date_option = 'custom'
                            this.custom_date = this.$route.query.filter_by_date
                        }
                    }
                } else {
                    this.date_option = moment().format('YYYY-MM-DD')
                }
                if (this.$route.query.user_id) {
                    this.user_id = this.$route.query.user_id
                }
            },
            replaceState(){
                let args = {}
                let query = objToUrl(args)
                let url = this.$route.path
                if (query) {
                    url = `${url}?${query}`
                }
                if (url !== this.$route.fullPath) {
                    try {
                        this.$nextTick(async () => {
                            await this.$router.replace(url);
                            await this.addToNextPrevStack({ids: this.ids});
                        })
                    } catch (e) {
                        console.warn('error in router.replace', e)
                    }
                }
            },

            onViewChange(){
                this.replaceState()
                this.$unFocusElement('input[type="radio"]')
            },
            resetForm(){
                this.search_chassis = ''
                this.search_lot = ''
                this.current_page = 1;
                this.getData()
            },
            onSearchChange(){
                this.current_page = 1;
            },
            onTagChanged(data){
                if (data.removed) {
                    if (data.tags_left === 0 && this.vehicleFavourites[data.vehicle_id]) {
                        Vue.set(this.vehicleFavourites, data.vehicle_id, null)
                    }
                } else {
                    Vue.set(this.vehicleFavourites, data.vehicle_id, true)
                }
            },
            onFavChange(vid){
                if (this.vehicleFavourites[vid]) {
                    this.$store.dispatch('favourites/addFavourite', vid);
                } else {
                    this.$store.dispatch('favourites/removeFavourite', vid);
                }
            },
            openFavouriteTagList(vehicle_id) {
                this.favListModalOpen = true;
                this.vehicle_id = vehicle_id;
                this.$store.dispatch('favouriteTags/getTags', {});
            },
            tagPopupModal(vehicle_id) {
                this.openFavouriteTagList(vehicle_id);
            },
            onBidFavChange(bid){
                if (this.bidFavourites[bid]) {
                    this.$store.dispatch('bidFavourites/addFavourite', bid);
                } else {
                    this.$store.dispatch('bidFavourites/removeFavourite', bid);
                }
            },
            selectMessage(msg) {
                if (this.selectedMessage && this.selectedMessage.id === msg.id) {
                    this.selectedMessage = null
                } else {
                    this.selectedMessage = msg
                }
            },
            messageClass(msg, bid){
                let classes = []
                if (this.selectedMessage && this.selectedMessage.id === msg.id) {
                    classes.push('selected')
                }
                if (msg.user_id === bid.user_id) {
                    classes.push('bidder-message')
                } else if (msg.rep_only){
                    classes.push('staff-message')
                }
                return classes
            },
            onUserChange(){
                this.getData();
            },
            getDataQuery(params){
                let data = Object.assign({
                    filter_by_date: this.date,
                    page: this.current_page,
                    user_id: this.user_id,
                }, params);
                return data
            },
            getData: _.debounce(async function(params){
                this.$nextTick(async () => {
                    this.empty_message = 'Loading...';
                    try {
                        let data = this.getDataQuery(params)
                        console.log('getData', data)
                        await Promise.all([
                            this.$store.dispatch('vehicleViews/getVehicleViews', data),
                        ]);

                        let favs = {};
                        let bid_favs = {}
                        let ids = [];
                        if (this.vehicleViews && this.vehicleViews.length){
                            this.vehicleViews.forEach(view => {
                                if (view.vehicle) {
                                    ids.push(view.vehicle.api_id)
                                }
                                if (view.vehicle && view.vehicle.favourites && view.vehicle.favourites.length) {
                                    favs[view.vehicle.api_id] = true
                                } else {
                                    favs[view.vehicle.api_id] = false
                                }

                                if (view.vehicle && view.vehicle.bids && view.vehicle.bids.length) {
                                    view.vehicle.bids.forEach(b => {
                                        if (b.favourites && b.favourites.length) {
                                            bid_favs[b.id] = true
                                        } else {
                                            bid_favs[b.id] = false
                                        }
                                    })
                                }
                            })
                        }
                        this.replaceState()
                        await this.addToNextPrevStack({ids: ids});
                        this.vehicleFavourites = favs;
                        this.bidFavourites = bid_favs;
                        this.empty_message = this.default_empty_message;
                    } catch (e) {
                        this.empty_message = 'There was a problem loading the users.';
                    }
                })
            }, 250),
            bidColourStyle(bid){
                if (bid && bid.user && bid.user.profile && bid.user.profile.bid_color) {
                    return 'background-color: ' + bid.user.profile.bid_color;
                }
                return '';
            },
            bumpBidDisplay(number){
                if (!number) {
                    return '';
                }
                let k = number / 1000;
                return `Bump ${k}k`
            },
            formatNumber(val) {
                return numberWithCommas(val);
            },
            getDate(data) {
                return window.moment(data).format(this.defaultMomentDateFormat())
            },
            getTime(data) {
                return window.moment(data).format('HH:mm')
            },
            async makeBid(vehicle_id) {
                if (this.userHasBid) {
                    alert('You have already placed a bid.');
                } else if (vehicle_id && this.bidPrice) {
                    try {
                        let result = await this.$store.dispatch('vehicleViews/storeBid', {
                            api_id: vehicle_id,
                            landed_price: this.estimatedLandedCost,
                            note: this.bidNote,
                        });
                        if (result && result.data) {
                            this.bids.push(result.data);
                            this.calculatedBidPrice = '';
                            this.estimatedLandedCost = '';
                        }
                    } catch (e) {
                        handleHttpError(e);
                    }
                }
            },
            async cancelBid(bid_id) {
                try {
                    const result = await this.$store.dispatch('vehicleViews/cancelBid', {bid_id});
                    if (result.message) {
                        this.bids.forEach((bid) => {
                            bid.bids.forEach((userBid, i) => {
                                if (userBid.id === bid_id) {
                                    if (result.bid) {
                                        userBid.bid_price_jpy = result.bid.bid_price_jpy;
                                        userBid.bid_price_landed = result.bid.bid_price_landed;
                                    }
                                }
                            });
                        });
                        this.updateViewMessages({bid_id, message: result.message});
                    }
                } catch (e) {
                    handleHttpError(e);
                }
            },
            async addBidMessage(bid_id, message, rep_only) {
                try {
                    const result = await this.$store.dispatch('vehicleViews/addBidMessage', {bid_id, rep_only, message});
                    if (result && result.bid_message) {
                        this.updateViewMessages({bid_id, message: result.bid_message});
                    }
                } catch (e) {
                    handleHttpError(e);
                }
            },
            openMessageModal(bid) {
                let msg = ''
                if (this.selectedMessage)
                    msg = this.selectedMessage.message.replace(/\[.*\]/, '')
                this.$refs.bidMessage.openModal(bid, null, msg);
            },
            openStaffMessageModal(bid) {
                this.$refs.staffMessage.openModal(bid);
            },
            changeBidButton() {
                let bid = this.userHasBid;
                this.openChangeBidModal(bid);
            },
            openChangeBidModal(bid) {
                if (this.$canChangeBid(bid.auction_date)) {
                    this.$refs.changeBidModal.openModal(bid);
                } else {
                    this.$message.error("Bids can't be changed this close to the auction time.")
                }
            },
            onBidChange(bid_id, message) {
                this.updateViewMessages({bid_id, message});
            },
            convertEquipment(item) {
                if(item) {
                    let html = item.replace(/ /g, ', ');
                    html = html.toUpperCase();
                    return html;
                }

                return '';
            },
            getVehicleLink(vehicle) {
                return this.$laravelRoute('vehicle-detail', {id: vehicle.api_id});
            },
            displayAuctionHouse(orig_name) {
                let auctionName = '';
                let name = orig_name.replace(/[^a-zA-Z]/, ' ').replace(/\s{2,}/, ' ');
                // Auction name split in an array
                if (name.indexOf(' ') !== -1) {
                    let arrayName = name.split(' ');
                    // Compose the auction name 2 chars for the first word and 3 chars for the second word.
                    auctionName = arrayName[0].slice(0, 2) + '-' + arrayName[1].slice(0, 3)
                } else if (name.length > 2) {
                    auctionName = name.slice(0, 2);
                }
                return auctionName;
            },
        }


    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleViewsPage.vue